import { type GetStaticProps } from 'next';
import { CaseStudyHome } from '../../components/customers/home/Home';
import {
  getAllCaseStudySummaries,
  CaseStudySummary,
} from '@/components/customers/utils'

interface Props {
  caseStudies: CaseStudySummary[];
}

export default function CaseStudyIndexPage({ caseStudies }: Props) {
  return <CaseStudyHome caseStudies={caseStudies} />;
}

export const getStaticProps: GetStaticProps<Props> = async () => {
  return {
    props: {
      caseStudies: getAllCaseStudySummaries(),
    }
  }
}